import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MD_DIALOG_DATA, MdDialog, MdDialogRef, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { SharedService } from '../../../Common/Services/shared.service';
import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { TableDataSource } from './../../../Common/md-table';
import { Utility } from './../../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../../dialog-confirm-component/dialog-confirm-component.component';
import { KoalaConfigService } from './adm-manage-koalaconfig.service';
import { AppConfig } from './../../../Common/appConfiguration';

@Component({
  selector: 'app-adm-manage-koalaconfig',
  templateUrl: './adm-manage-koalaconfig.component.html',
  styleUrls: ['./adm-manage-koalaconfig.component.css'],
  providers: [KoalaConfigService]
})
export class AdmManageKoalaconfigComponent implements OnInit {

  KoalaItemGroupIndex: any[];
  @ViewChild(MdSort) sort: MdSort;
  locationId: number;
  locationStatus: number = 0;
  countListItems: number = 0;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  dataSource: TableDataSource | null;
  displayedColumns = ['serialNumber', 'macAddress', 'koalaId', 'koalaStatus', 'action'];

  koalaConfigForm: FormGroup;
  constructor(
    public dialogRef: MdDialogRef<AdmManageKoalaconfigComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    private _koalaService: KoalaConfigService, public _utility: Utility, private _sharedService: SharedService, public _dialog: MdDialog, private _appMessage: AppMessage
  ) {
    this.locationId = Number(this.data);
    this.getKoala("?locationId=" + this.locationId);
  }

  ngOnInit() {
    this.koalaConfigForm = new FormGroup({
      0: new FormGroup({  // "0" is the first initial item of group (serial number and mac address)
        serialNo: new FormControl('', Validators.required),
        macAddress: new FormControl('', [Validators.required, Validators.pattern(AppConfig.macAddressRegEx)])
      })
    });
    this.KoalaItemGroupIndex = Object.keys(this.koalaConfigForm.controls);
    this.dataSource = new TableDataSource(this.dataSubject, null, this.sort); // second parameter is null : defines that we don't need pagination in this page
  }

  /**
   * Add : autmatically after 2 chars typed.
   * @param groupIndex - this is group index of mac address field
   */
  onKeyup(groupIndex: number) {
    let field = (<any>this.koalaConfigForm.controls[groupIndex]).controls.macAddress;
    let formattedValue = this._utility.textFormat(field.value.replace(/:/g, ""), 2, ":"); // format text with ":"
    field.setValue(formattedValue.substring(0, 17)); // substring(0, 17) -- this logic works if someone long press any key then only take start 17 inputs only
  }

  // get Koalas 
  getKoala(params: string) {
    this._utility.addLoaderCount();
    this._koalaService.getKoala(params).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        let data = response.response.results;
        if (data.length > 0) {
          this.checkKoalaStatus(data);
        }
        this.dataSubject.next(data);
        this.countListItems = data.length;
      });

    }, error => this._utility.onErrorCallback(error));
  }


  /*
   * 2 - status pending & 1- status active
   * check the status of kaola if it is active
   * if no sysytem is active disable retire button
   * if any one is active enable retire button
  */
  checkKoalaStatus(data) {
    let c = 0;
    data.filter(elm => {
      if (elm.koalaStatusCode.toUpperCase() === "ACTIVE") {
        c++;
      }
    })
    this.locationStatus = c == 0 ? Enum.StatusPending : Enum.StatusActive;
    return;
  }

  /**
   * When click on Add , a new row will be added in form with field serial number & mac address
   * @param index - position
   * @param perfectScrollSection  - this is scroll div element
   */
  onAdd(index: number, perfectScrollSection: any): void {
    index = Number(index);
    let objControl = new FormControl('', Validators.required);
    let maxIndex = Math.max.apply(this, this.KoalaItemGroupIndex); // find max index which are already exist in form group 
    let newIndex = maxIndex + 1; // increase index (it will be newly added row Index)
    // create object for new group item
    let newItem = new FormGroup({
      serialNo: new FormControl('', Validators.required),
      macAddress: new FormControl('', [Validators.required, Validators.pattern(AppConfig.macAddressRegEx)])
    })
    this.koalaConfigForm.addControl(newIndex, newItem);
    this.KoalaItemGroupIndex = Object.keys(this.koalaConfigForm.controls);
    // update scroll position to bottom when add new element
    setTimeout(() => {
      perfectScrollSection.scrollTo(0, perfectScrollSection.scrollHeight);
    }, 40);
  }

  /**
   * When click on delete button selected row should removed
   * If there are more then 1 item then only remove
   * @param rowIndex - row index on which we have clicked
   * @param perfectScrollSection  - this is  perfect scrollbar element
   */
  onDelete(rowIndex: any, perfectScrollSection: any): void {
    rowIndex = Number(rowIndex);
    if (this.KoalaItemGroupIndex.length > 1) {
      this.koalaConfigForm.removeControl(rowIndex);
      this.KoalaItemGroupIndex = Object.keys(this.koalaConfigForm.controls);
      // update scroll position to bottom when add new element
      setTimeout(() => {
        perfectScrollSection.scrollTo(0, 0);
      }, 20);
    }
  }

  /**
 * RESET Form : remove dyanamically added field when click on requets system
 * perfectScrollSection : this is "ul" element of Form : we need to set scroll to 0 after remove elements to fix scroll
 */
  resetForm(perfectScrollSection) {
    this.koalaConfigForm.reset();
    let maxLength = this.KoalaItemGroupIndex.length;
    for (let i: number = 1; i <= maxLength; i++) {
      this.koalaConfigForm.removeControl(this.KoalaItemGroupIndex[i]);
    }
    this.KoalaItemGroupIndex = Object.keys(this.koalaConfigForm.controls);
    // Update scroll position
    if (perfectScrollSection) {
      perfectScrollSection.scrollTo(0, 0);
      setTimeout(() => {
        let scrollChild = perfectScrollSection.lastElementChild;
        scrollChild.style.height = 0;
        scrollChild && scrollChild.firstElementChild ? scrollChild.firstElementChild.style.height = 0 : '';
      }, 30);

    }
  }

  // When click on Request Koala Button
  requestKoala(perfectScrollSection) {
    let form = this.koalaConfigForm;
    if (form.invalid) {
      return;
    }

    let allKoalaValues = this._utility.objValues(form.getRawValue());  // get all koala request values (serial number and Mac address)
    let param = {
      locationId: this.locationId,
      koalaDetailList: allKoalaValues
    };

    this._utility.addLoaderCount();
    this._koalaService.addKoala(param).subscribe(response => {
      let message = this._appMessage.getItem['UMsg00008'];

      if (response.responseCode == 'E0001') {
        message = this._appMessage.getItem['UMsg00007'];
      } else if (response.responseCode == 'P0001') {
        let res = response.response;
        let sList = res.successList || [];
        let fList = res.failureList || [];
        message = `${sList.length} ${message} and ${fList.length} ${this._appMessage.getItem['UMsg00007']}`;
      }
      this._utility.onSuccessCallback(response, message, () => {
        this.getKoala("?locationId=" + this.locationId);
        this.resetForm(perfectScrollSection);
      });
    }, error => this._utility.onErrorCallback(error));
  }


  // When click on active or retire button 
  onChangeStatus(status, id) {
    let instance = this._dialog.openDialogs[0];
    this._dialog.openDialogs.pop(); //to clear instance of first dialog box to opnen another on it(issue in IE,edge and safari) 
    let message;  // this same message we have to show after success
    switch (status) {
      case Enum.StatusActive:
        message = this._appMessage.getItem['UMsg00026'];
        break;
      case Enum.StatusRetire:
        message = this._appMessage.getItem['UMsg00027'];
        break;
      default:
        message = this._appMessage.getItem['UMsg00028'];
        break;
    }

    let confirmDialogMsgModel = {
      modelType: "CONFIRMATION",
      msgTitle: this._appMessage.getItem['Common007'],
      msg: this._appMessage.getItem['UMsg00046'],
      isConfirmBox: true
    };

    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      if (result == "1") {
        this._utility.addLoaderCount();
        this._sharedService.changeStatus(id, Enum.Koala, status).subscribe(response => {
          this._utility.onSuccessCallback(response, message, () => {
            // reload koala grid to get latest updated koala status
            this.getKoala("?locationId=" + this.locationId);
            
          });
        }, error => this._utility.onErrorCallback(error));
      }
    });
    this._dialog.openDialogs.push(instance); //popped instance pushed again to maintain its normal behavior
  }

  // To close the current dialog
  closeDialog(dialogResult: any = 0) {
    this.dialogRef.close(this.locationStatus);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-manage-koalaconfig/adm-manage-koalaconfig.component.ts